import React, { useState, useEffect, useRef } from "react";
import "./MobileVerificationFCM.css";
import { Redirect } from "react-router";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as AppUrls from "../../constants/AppUrls";
import * as Constants from "../../constants/Constants";
import { useTranslation } from "react-i18next";
import * as utils from "../../global/utils";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../store/actionTypes";
import * as Helpers from "../../global/Helpers";
import i18next from "i18next";
import "react-simple-keyboard/build/css/index.css";
import { otpSessionId } from "./Login.js"; 
const MobileVerificationFCM = (props) => {
  const { t, i18n } = useTranslation();
  const [deviceName] = useState("");
  const [redirect, setRedirect] = useState(null);
  const dispatch = useDispatch();
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);
  const abortController = new AbortController();



  const [isDisabled, setIsDisabled] = useState(true);
    // const [timer, setTimer] = useState(60); // 60 seconds
  
      const DeviceConfigs = JSON.parse(localStorage.getItem("DeviceConfigs"));
  
    const tokenExpireSeconds =
      DeviceConfigs 
        ? Number(DeviceConfigs.TokenMinutesExpire) * 60
        : 60; // fallback
  
    const [timer, setTimer] = useState(tokenExpireSeconds);



    useEffect(() => {
  const fcmActive = sessionStorage.getItem("FCM_VERIFICATION_ACTIVE");

  if (!fcmActive) {
   
    setRedirect(AppUrls.login);
  }

  return () => {

    sessionStorage.removeItem("FCM_VERIFICATION_ACTIVE");
  };
}, []);



    useEffect(() => {
      let interval = null;
  
      if (isDisabled) {
        interval = setInterval(() => {
          setTimer((prevTimer) => {
            if (prevTimer <= 1) {
              clearInterval(interval);
              setIsDisabled(false);
              return 0;
            }
            return prevTimer - 1;
          });
        }, 1000);
      }
  
      return () => clearInterval(interval);
    }, [isDisabled]);

  useEffect(() => {
    debugger
    CallCheckApproveNotificationVasco();
    const interval = setInterval(() => {
      CallCheckApproveNotificationVasco();
    }, 10000);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      callLogOff();
    }, 300000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  

   function CallCheckApproveNotificationVasco(e) {
    // var passwordToOTp =
    debugger
    //   localStorage.getItem("passwordToOTp") === "false"
    //     ? ""
    //     : localStorage.getItem("passwordToOTp");
    // var isAuthorizeOnly =
    //   localStorage.getItem("passwordToOTp") === "false" ? "Y" : "N";

      const encPass = otpSessionId ? otpSessionId.value : ""
    var passwordToOTp =
      encPass === "false"
        ? ""
        : encPass;
    var isAuthorizeOnly =
     encPass === "false" ? "Y" : "N";

    var response = utils.CheckLoginApproval(
      localStorage.getItem("username"),
      localStorage.getItem("WebCode"),
      "",
      passwordToOTp,
      "",
      "",
      isAuthorizeOnly,
      "N"
    );

    response
      .then((response) => {
        // setVisible(false);
debugger
        let responseJson = response.data;
        let webcode = responseJson["WebCode"];
        let isFirstLoggedIn = response.data["IsFirstLogin"]; //localStorage.getItem("isFirstLoggedIn");

        if (
          webcode !== undefined &&
          webcode !== null &&
          webcode !== "" &&
          webcode !== "-1" &&
          responseJson["Status"] === "0"
        ) {
          if (isFirstLoggedIn === "Y") {
            localStorage.setItem("WebCode", webcode);
            localStorage.setItem("loginFirst", true);
            localStorage.setItem("validValue", "");
            localStorage.setItem(
              "isTermsAndConditions",
              response.data["isTermsAndConditions"]
            );
            localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);

            localStorage.setItem(
              "ExpiredDocument",
              response.data["isExpiredDocument"]
            );
            localStorage.setItem("isIndividual", response.data["isIndividual"]);
            localStorage.setItem("user", JSON.stringify(response.data));
            localStorage.setItem("IsNormalLogin", true);

            getUserSettings();
            setRedirect(AppUrls.changePassword);

            return;
          } else {
            Helpers.successNotify(t("Successful_Login!"), i18next.language);
            localStorage.setItem("WebCode", webcode);
            localStorage.setItem("loginFirst", true);
            localStorage.setItem(
              "isTermsAndConditions",
              response.data["isTermsAndConditions"]
            );
            localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);
            getUserSettings();
            localStorage.setItem("user", JSON.stringify(response.data));

            localStorage.setItem(
              "ExpiredDocument",
              response.data["isExpiredDocument"]
            );
            localStorage.setItem("isIndividual", response.data["isIndividual"]);
            localStorage.setItem("IsNormalLogin", true);
            clearInterval(intervalRef.current);
            clearTimeout(timeoutRef.current);
            setRedirect(AppUrls.trading);
          }
        } 
      })
      .catch((error) => {
        // setVisible(false);
        console.log("error", error);
        Helpers.errorNotify(error.message, i18n.language);
      });
  }
  const getUserSettings = () => {
    let response = utils.GetSettingWorkSpaceByUserID();
    response
      .then((response) => {
        //
        let data = response.data[0];
        if (
          data.WorkSpaceSettings !== undefined &&
          data.WorkSpaceSettings !== null &&
          data.WorkSpaceSettings !== ""
        ) {
          var res = JSON.parse(data.WorkSpaceSettings);

          localStorage.setItem("selectedProfile", res.selectedProfile);
          localStorage.setItem("theme", res.theme);
          localStorage.setItem("UserSettings", data.WorkSpaceSettings);

          dispatch({
            type: actions.SELECT_PREFERRED_SYMBOL,
            payload: {
              PreferredSymbol: res.PreferredSymbol,
            },
          });

          dispatch({
            type: actions.SELECT_PREFERRED_EXCHANGE,
            payload: {
              PreferredExchange: res.PreferredExchange,
            },
          });

          dispatch({
            type: actions.UPDATE_ENABLE_EXPAND_ROW,
            payload: {
              EnableExpandRow: res.expandRow === "Y" ? true : false,
            },
          });

          dispatch({
            type: actions.ENABLE_TRADE_TICKER,
            payload: {
              EnableTradeTicker: res.tradeTicker === "Y" ? true : false,
            },
          });

          dispatch({
            type: actions.ENABLE_ROUND_TICKER,
            payload: {
              EnableRoundTicker: res.RoundTicker === "Y" ? true : false,
            },
          });
          saveSettings(data);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  function saveSettings(data) {
    var res = JSON.parse(data.WorkSpaceSettings);
    let LanguageSelectedFromLogin = localStorage.getItem(
      "LanguageSelectedFromLogin"
    );
    let isLanguageSelectedFromLogin = localStorage.getItem(
      "isLanguageSelectedFromLogin"
    );
    var lang = "";
    if (isLanguageSelectedFromLogin === "true")
      lang = LanguageSelectedFromLogin;
    else lang = res.lang;
    let settings = {
      lang: lang,
      theme: res.theme,
      //theme: '',
      expandRow: res.expandRow,
      PreferredSymbol: res.PreferredSymbol,
      PreferredExchange: res.PreferredExchange,
      selectedProfile: res.selectedProfile,
      tradeTicker: res.tradeTicker,
      RoundTicker: res.RoundTicker,
    };

    if (data !== undefined && data !== null) {
      let postdata = {
        profileUniqueID: data.profileUniqueID,
        ProfileID: data.ProfileID,
        ProfileName: data.ProfileName,
        ProfileNameAr: data.ProfileNameAr,
        ProfileSettings: data.ProfileSettings,
        WorkSpaceSettings: JSON.stringify(settings),
        WebCode: localStorage.getItem("WebCode"),
      };
      var updateWorkSpaceSettings = utils.UpdateUserProfileSettings(postdata);
      updateWorkSpaceSettings
        .then((response) => {
          if (response.data) {
            // console.log("Settings Successfully Updated");
            // this.props.setUserSettings(settings)
            localStorage.setItem("UserSettings", JSON.stringify(settings));

            if (i18n.language === "ar" && settings.lang === "en")
              props.changeLanguageNew();
            else if (i18n.language === "en" && settings.lang === "ar")
              props.changeLanguageNew();
          } else {
            console.log(
              "Unsuccessfull Update Settings, please contact Administrator"
            );
          }
        })
        .finally(() => {
          if (abortController) abortController.abort();
        })
        .catch((error) => {
          console.log(
            "Unsuccessfull Update Settings, please contact Administrator"
          );
          if (abortController) abortController.abort();
        });
    }
  }



   const reSendOTP = () => {
      var url =
        Constants.reSendUserToken +
        localStorage.getItem("username") +
        "/" +
        localStorage.getItem("WebCode");
      var reSendUserToken = utils.reSendUserToken(url);
      reSendUserToken
        .then((response) => {
          if (response.data) {
             
            Helpers.successNotify(t("ReSendOTPMSG"), i18n.language);
            setIsDisabled(true);
                const DeviceConfigs = JSON.parse(localStorage.getItem("DeviceConfigs"));
  
            const tokenExpireSeconds =
              DeviceConfigs 
                ? Number(DeviceConfigs.TokenMinutesExpire) * 60
                : 60; // fallback
  
  
            setTimer(tokenExpireSeconds); // Reset timer based on TokenMinutesExpire
            console.log("response.data:", response.data);
console.log("AppUrls.otp:", AppUrls.otp);
console.log("current path:", window.location.pathname);

              setRedirect(AppUrls.otp);
         //   setTimer(60); // Reset the timer to 60 seconds
          } else {
            Helpers.errorNotify(t("somethingwentwrong"), i18n.language);
          }
        })
        .catch((error) => {
          Helpers.errorNotify(t("somethingwentwrong"), i18n.language);
        });
    };

  const callLogOff = () => {
    //
    // props.setIsLoaderVisible(true);
    //console.log("logging out...");
    let logOffResponse = utils.logOff();
    logOffResponse
      .then((response) => {
        // props.setIsLoaderVisible(false);
        //console.log("Logged Off", response)
        if (response.status === 200) {
          localStorage.removeItem("user");
          localStorage.removeItem("ExpiredDocument");
          let UserName = localStorage.getItem("username");
          let RememberMe = localStorage.getItem("isRememberMe");
          let language = localStorage.getItem("language");

          let Comapnyname = localStorage.getItem(
            Constants.localStorageConstants.company_name
          );
          var prev = Helpers.getPreviousConfig();

          if (RememberMe === "true") {
            localStorage.clear();
            localStorage.setItem("isRememberMe", true);
            localStorage.setItem("username", UserName);
            localStorage.setItem("language", language);

            localStorage.setItem(
              Constants.localStorageConstants.company_name,
              Comapnyname
            );
          } else {
            localStorage.clear();
            localStorage.setItem("language", language);

            localStorage.setItem(
              Constants.localStorageConstants.company_name,
              Comapnyname
            );
          }
          Helpers.SetpreviosConfig(prev);
          setRedirect(AppUrls.login);
          //   setState({ redirect: AppUrls.login }, () => {
          //     disconnectSignalr();
          //   });
        } else {
                  setRedirect(AppUrls.login);

        }
      })
      .catch((error) => {
        setRedirect(AppUrls.login);
        //props.setIsLoaderVisible(false);
        //console.log("error", error);
      });
  };

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

 return (
  <div className="fcm-verify-page">
    <div className="fcm-verify-card">
      <div className="fcm-verify-brand" />

      <div className="fcm-verify-content">
        <h1 className="fcm-verify-title">{t("Step Verification")}</h1>
        <p className="fcm-verify-subtitle">
          {t("Please verify this login request on your registered mobile device")}
        </p>

        <div className="fcm-verify-info">
          <div className="fcm-verify-dot" />
          <div className="fcm-verify-info-text">
            <div className="fcm-verify-info-title">
              {t("A notification has been sent to your mobile device.")}
            </div>
            {/* <div className="fcm-verify-info-desc">
              {t("Open the trading app and approve the login request.")}
            </div> */}
          </div>
        </div>

        <div className="fcm-verify-timer">
          <span className="fcm-verify-timer-label">{t("Waiting for approval...")}</span>
          <span className="fcm-verify-timer-hint">{t("This page will expire in 5 minutes.")}</span>
        </div>

        <div className="fcm-verify-actions">
          <button
            className="fcm-verify-cancel"
            onClick={() => {
              localStorage.removeItem("user");
              localStorage.removeItem("ExpiredDocument");
              setRedirect(AppUrls.login);
            }}
          >
            {t("cancelForgotPassword")}
          </button>
        </div>

        <div className="fcm-verify-footer">
       <button
  type="button"
  onClick={reSendOTP}
  disabled={isDisabled}
  style={{
    background: "none",
    border: "none",
    padding: 0,
    color: isDisabled ? "#9ca3af" : "#2563eb",
    textDecoration: "underline",
    cursor: isDisabled ? "not-allowed" : "pointer",
    textAlign: "start"
  }}
>
  {t("Didn’t receive it?")}{" "}
  {isDisabled &&
    (i18n.language === "ar"
      ? `${timer} ثانية`
      : `in ${timer}s`)}
</button>


          <span className="fcm-verify-footer-muted">
            {t("Make sure notifications are enabled for the trading app.")}
          </span>
        </div>
      </div>
    </div>
  </div>
);

};

export default MobileVerificationFCM;
